/**
 * Display helpers for the reservations slice.
 *
 * Several canonical fields are typed `unknown` (the documented contract gap for
 * nullable scalars in responses.ts). These helpers coerce them to safe display
 * primitives without inventing data.
 */

import { ApiError } from '@hostesa/api-client';

/** Coerce an `unknown` scalar to a trimmed string, or undefined when empty/absent. */
export function asString(value: unknown): string | undefined {
  if (value === null || value === undefined) return undefined;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return undefined;
}

/** Coerce an `unknown` scalar to a finite number, or undefined. */
export function asNumber(value: unknown): number | undefined {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const n = Number(value);
    return Number.isFinite(n) ? n : undefined;
  }
  return undefined;
}

/** Whether an error is a 409 conflict (invalid-state on the backend). */
export function isConflict(err: unknown): boolean {
  return err instanceof ApiError && err.isConflict;
}
